import { render, staticRenderFns } from "./KidsOrdersList.vue?vue&type=template&id=7416b44c&scoped=true&"
import script from "./KidsOrdersList.vue?vue&type=script&lang=js&"
export * from "./KidsOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./KidsOrdersList.vue?vue&type=style&index=0&id=7416b44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7416b44c",
  null
  
)

export default component.exports